import { applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "./reducer";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

const getMiddleware = () => {
  if (process.env.NODE_ENV === "production") {
    return applyMiddleware(thunk);
  } else {
    // Enable additional logging in non-production environments.
    // return applyMiddleware(createLogger(), thunk);
    return applyMiddleware(thunk);
  }
};

export const store = createStore(persistedReducer, composeWithDevTools(getMiddleware()));
export const persistor = persistStore(store);
